import type { MouseEventHandler } from 'react'
import { StageSelfCheck, stageByNo } from '../../../entities/journey'
import type { JourneyView } from '../model/types'
import styles from './JourneyPage.module.css'

interface Props {
  data: JourneyView
  dismissed: boolean
  saving: boolean
  confirmBreakup: boolean
  onResolve: MouseEventHandler<HTMLButtonElement>
  onBeginBreakup: () => void
  onCancelBreakup: () => void
}
export default function StageTransition({ data, dismissed, saving, confirmBreakup, onResolve, onBeginBreakup, onCancelBreakup }: Props) {
  if (!data.stageNo || !data.ready) return null
  if (dismissed) return <section className={styles.card}>
    <p>Хорошо, остаёмся здесь. Перейти дальше можно в любой момент.</p>
    <button className={styles.secondary} value="review" onClick={onResolve} disabled={saving}>Вернуться к выбору</button>
  </section>
  const fork = data.forkOptions.length > 0
  const last = data.stageNo === data.total
  const nextStage = stageByNo(data.content, data.stageNo + 1)
  return <section className={styles.card} aria-labelledby="transition-title">
    <p className={styles.eyebrow}>Задания недели выполнены</p>
    <h2 id="transition-title">{fork ? 'Куда дальше?' : last ? 'Завершение пути' : `Следующая стадия — ${data.state.pending_next?.title ?? nextStage?.title ?? ''}`}</h2>
    {fork && !confirmBreakup ? <>
      <p>По итогам срока выберите, что вам сейчас подходит. Решение остаётся за вами.</p>
      <div className={styles.actions}>
        {data.forkOptions.includes('split') && <button className={styles.secondary} onClick={onBeginBreakup} disabled={saving}>Расстаться</button>}
        {data.forkOptions.includes('keep') && <button className={styles.secondary} value="preserve" onClick={onResolve} disabled={saving}>Сохранять отношения</button>}
        {data.forkOptions.includes('extend') && !data.extensionUsed && <button className={styles.secondary} value="extend" onClick={onResolve} disabled={saving}>Продлить срок</button>}
      </div>
    </> : last ? <>
      <p>Вы отметили задания последней стадии. Путь пройден: его можно перечитать ниже, вернуться к любому заданию или просто поговорить, когда захочется.</p>
    </> : <>
      {nextStage && <StageSelfCheck key={nextStage.id} stage={nextStage} disabled={saving} />}
      {confirmBreakup && fork
        ? <div className={styles.actions}>
            <button className={styles.primary} value="split" onClick={onResolve} disabled={saving}>Да, расстаться</button>
            <button className={styles.secondary} onClick={onCancelBreakup} disabled={saving}>Назад к выбору</button>
          </div>
        : <button className={styles.primary} value="advance" onClick={onResolve} disabled={saving}>Перейти на следующую стадию</button>}
      {confirmBreakup && fork && <p>Шаг необратим: задания пути рассчитаны на расставание.</p>}
    </>}
    <div className={styles.actions}>
      <button className={styles.secondary} value="stay" onClick={onResolve} disabled={saving}>Остаться на этой стадии</button>
    </div>
  </section>
}
